// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import {FormattedMessage} from 'react-intl';
import PipStatuses from '../state/pip-statuses';
import {create as createHashMap} from '../../../shared/services/hashmap';

const OpenPipProgramsPipStatusCriteria = props => {

    const buttonText = props.pipStatuses.selected.length > 0 ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (
        <section className='open-pips-pip-status-criteria'>
            <CheckboxListWithLabel
                className='open-pips-status'
                initialState={createHashMap(props.pipStatuses.selected, 'key')}
                isRequired={false}
                label='PIP_STATUS'
                list={props.pipStatuses.allowed}
                onChange={props.onPipStatusSelect}
                uid='key'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllPipStatuses}
                type='button'
            >
                <FormattedMessage id={buttonText}/>
            </button>
        </section>
    );

};

OpenPipProgramsPipStatusCriteria.displayName = 'OpenPipProgramsPipStatusCriteria';
OpenPipProgramsPipStatusCriteria.propTypes = {
    onPipStatusSelect: PropTypes.func.isRequired,
    onSelectAllPipStatuses: PropTypes.func.isRequired,
    pipStatuses: PropTypes.instanceOf(PipStatuses).isRequired
};

export default OpenPipProgramsPipStatusCriteria;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/components/open-pip-programs-pip-status-criteria.js